import cmedLogo from '../../img/cmeducation_ani.gif'

export default function LoaderOverlay() {
    return (
        <div id="overlay">
            <div id="progstat">Wird geladen 0%</div>
            <div id="welcome"></div>
            <div id="progress"></div>
            <div id="progimage">
                <img id='loader-logo' src={cmedLogo} alt="" />
            </div>
        </div>
    )
}